// Merchant portal API client — all calls hit /api/merchant/* and require
// IsMerchantUser on the backend (role=='merchant' AND owns a Store).

import axios from 'axios';
import API_BASE_URL from '../config';

const BASE_URL = `${API_BASE_URL}/api/merchant`;

function authHeaders(extra = {}) {
  const token = localStorage.getItem('accessToken');
  return {
    Authorization: `Bearer ${token || ''}`,
    'Content-Type': 'application/json',
    ...extra,
  };
}

function handle401(err) {
  if (err?.response?.status === 401) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login';
  }
  throw err;
}

export async function getMe() {
  try {
    const res = await axios.get(`${BASE_URL}/me/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function getAnalytics() {
  try {
    const res = await axios.get(`${BASE_URL}/analytics/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function getSubscription() {
  try {
    const res = await axios.get(`${BASE_URL}/subscription/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

// ---------- coupons ----------
export async function listCoupons() {
  try {
    const res = await axios.get(`${BASE_URL}/coupons/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function createCoupon(body) {
  try {
    const res = await axios.post(`${BASE_URL}/coupons/`, body, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function updateCoupon(couponId, patch) {
  try {
    const res = await axios.patch(`${BASE_URL}/coupons/${couponId}/`, patch, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function deleteCoupon(couponId) {
  try {
    const res = await axios.delete(`${BASE_URL}/coupons/${couponId}/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

// ---------- flyers ----------
export async function listFlyers() {
  try {
    const res = await axios.get(`${BASE_URL}/flyers/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function uploadFlyer({ image, valid_from, valid_until }) {
  const formData = new FormData();
  formData.append('image', image);
  formData.append('valid_from', valid_from);
  formData.append('valid_until', valid_until);
  try {
    const res = await axios.post(`${BASE_URL}/flyers/upload/`, formData, {
      headers: authHeaders({ 'Content-Type': 'multipart/form-data' }),
    });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function toggleFlyer(flyerId) {
  try {
    const res = await axios.patch(`${BASE_URL}/flyers/${flyerId}/toggle/`, {}, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}

export async function deleteFlyer(flyerId) {
  try {
    const res = await axios.delete(`${BASE_URL}/flyers/${flyerId}/`, { headers: authHeaders() });
    return res.data;
  } catch (e) { handle401(e); }
}
